'use client';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { PropsWithChildren, useState, useCallback, useMemo } from 'react';
import { SearchParamsObserver } from './SearchParamsObserver';
import {
  SearchParamsContext,
  SearchParamsContextProps,
  SearchParamsContextValue,
} from './useSafeSearchParams';

export const SafeSearchParamsProvider: React.FC<
  PropsWithChildren<SearchParamsContextProps>
> = ({ children, ...other }) => {
  const [searchParams, setSearchParams] =
    useState<ReadonlyURLSearchParams | null>(other.searchParams);
  const [searchParamsReady, setSearchParamsReady] = useState(false);

  const handleSetSearchParams = useCallback(
    (params: ReadonlyURLSearchParams | null) => {
      setSearchParams(params);
      setSearchParamsReady(true);
    },
    [],
  );

  const value: SearchParamsContextValue = useMemo(
    () => ({
      searchParams,
      searchParamsReady,
      setSearchParams: handleSetSearchParams,
    }),
    [searchParams, searchParamsReady, handleSetSearchParams],
  );

  return (
    <SearchParamsContext.Provider value={value}>
      <SearchParamsObserver />
      {children}
    </SearchParamsContext.Provider>
  );
};
